import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, MemoryRouter } from 'react-router';
import { AuthGate } from './auth/AuthGate';
import { Shell } from './layout/Shell';
import './styles/app.css';

// Na demonstração (página única, publicada como link) as rotas ficam em memória.
const Router = import.meta.env.VITE_DEMO ? MemoryRouter : BrowserRouter;

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: true, retry: 1 } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthGate>
          <Shell />
        </AuthGate>
      </Router>
    </QueryClientProvider>
  </StrictMode>,
);
